import Fragment from "./fragment";
import FragmentDataType from "../enums/fragment-data-type";
import FragmentSummary from "./fragment-summary";
import { playerReducer } from "../../../storage/reducers";
import { FragmentMessages } from "../../common/fragment-messages";

/**
 * Bar Ball recovered by kicking team fragment for Indoor Football.
 * When the kickoff hits the goalpost and is recovered by the kicking team.
 */
export default class BarBallRecoveredKicking extends Fragment {
    constructor(recoveredBy, recoveredAt) {
        super();
        this.code = "BBRK";
        this.recoveredBy = recoveredBy;
        this.recoveredAt = recoveredAt;

        this.requiredData = [
            {
                name: "recoveredBy",
                type: FragmentDataType.Player,
                displayName: "Recovered By",
                title: (team) => `Recovered By: ${team.teamName}`,
                subtitle: (team) =>
                    `Select a player from ${team.teamName} or enter the roster number`,
                isEditable: true
            },
            {
                name: "recoveredAt",
                type: FragmentDataType.FieldPosition,
                displayName: "At",
                title: "Recovered At",
                subtitle: FragmentMessages.FB_TEAM_FIELD_POSITION
            }
        ];
    }

    getFieldPosition() {
        return this.recoveredAt;
    }

    getPlayers() {
        return [this.recoveredBy];
    }

    getFragmentTeamId() {
        return this.recoveredBy?.teamId;
    }

    summarize(summaryContext, stringifier) {
        const fieldPosition = stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            this.recoveredAt,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        );
        const message = `recovered by ${stringifier.firstInitial(
            this.recoveredBy
        )} at ${fieldPosition}`;
        return new FragmentSummary(message);
    }

    updateSummaryContext(summaryContext) {
        if (this.recoveredAt || this.recoveredAt === 0) {
            summaryContext.fieldPosition = this.recoveredAt;
        }
        summaryContext.playerInPossession = this.recoveredBy;
    }

    toJSON() {
        return {
            ...super.toJSON(),
            recoveredBy: playerReducer(this.recoveredBy)
        };
    }
}
